import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import qs from 'qs';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { Originator, Params } from 'types';

import { GridRightPanelProps } from './register-types';
import { MetadataApiRoute, SortOrder, ReportTemplateType } from 'enums';
import { DialogContext } from 'components/dialog/dialog-context';
import { DownloadMetadaDialog } from 'components/dialog/aisuk-dialogs/download-metadata-dialog';
import { useEadTreeContext } from 'components/grid/grid-ctx/EadTreeCtx';
import { getOriginatorFixedLink } from './reqister-utils';
import { NotificationCtx } from 'components/notification/notification-hook';
import { NotificationVariant } from 'components/notification/notification-types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minHeight: 'calc(100vh - 140px)',
      height: '100%',
      backgroundColor: 'white',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
    },
    title: {
      padding: theme.spacing(2),
    },
    buttons: {
      padding: 16,
      width: '90%',
    },
    button: {
      marginTop: theme.spacing(),
      alignSelf: 'baseline',
      width: '100%',
    },
  })
);

export function GridRightPanel({ detail }: GridRightPanelProps) {
  const classes = useStyles();
  const history = useHistory();
  const { open } = useContext(DialogContext);
  const etctx = useEadTreeContext();
  const { setOriginatorFilter } = etctx;
  const { showNotification } = useContext(NotificationCtx);
  const title = !!detail ? detail.preferredName?.label : 'Zvolte detail';

  const handleArchivalCollectionsLink = () => {
    const params: Params = {
      filters: [
        {
          operation: 'OR',
          filters: [
            { operation: 'EQ', field: 'originators.id', value: detail?.id },
            { operation: 'EQ', field: 'placesOfOrigin.id', value: detail?.id },
          ],
        },
      ],
    };

    if (detail) {
      setOriginatorFilter?.({ params, originator: detail });
    }

    history.push(`/fondy`);
  };

  const handleArchivalAidLink = () => {
    const params: Params = {
      filters: [
        {
          operation: 'OR',
          filters: [
            { operation: 'EQ', field: 'authors.id', value: detail?.id },
            { operation: 'EQ', field: 'originators.id', value: detail?.id },
            { operation: 'EQ', field: 'arrangers.id', value: detail?.id },
          ],
        },
      ],
    };

    if (detail) {
      setOriginatorFilter?.({ params, originator: detail });
    }
    history.push(`/pomucky`);
    //history.push(`/pomucky${queryParams}`);
  };

  const handleArchivalUnitsLink = () => {
    const params: Params = {
      filters: [
        {
          operation: 'EQ',
          field: 'originator.id',
          value: detail?.id,
        },
      ],
      sort: [{ field: 'numericId', order: SortOrder.ASC }],
    };

    if (detail) {
      setOriginatorFilter?.({ params, originator: detail });
    }

    const queryParams = qs.stringify(params, { addQueryPrefix: true });
    history.push(`/archivalie${queryParams}`);
  };

  const handleOpenDialog = () => {
    open({
      initialValues: {
        fileName: `o_${detail?.id}.pdf`,
        data: detail!,
        route: MetadataApiRoute.ORIGINATOR,
        templateType: ReportTemplateType.ORIGINATOR,
      },
      size: 'md',
      Content: (props) => <DownloadMetadaDialog<Originator> {...props} />,
    });
  };

  const handleCreateFixedLink = () => {
    if (detail) {
      const link = getOriginatorFixedLink(detail);
      navigator.clipboard.writeText(link);
      showNotification(
        'Odkaz byl vytvořen a skopírován do schránky.',
        NotificationVariant.SUCCESS,
        3500
      );
    }
  };

  return (
    <div className={classes.root}>
      <Typography variant="h6" className={classes.title}>
        {title}
      </Typography>

      {!!detail && (
        <div className={classes.buttons}>
          {[
            {
              title: 'Fondy',
              handleClick: handleArchivalCollectionsLink,
            },
            {
              title: 'Archivní pomůcky',
              handleClick: handleArchivalAidLink,
            },
            {
              title: 'Archiválie',
              handleClick: handleArchivalUnitsLink,
            },
            {
              title: 'Stáhni popis do PDF/XML',
              handleClick: handleOpenDialog,
            },
            {
              title: 'Vytvořit stálý odkaz',
              handleClick: handleCreateFixedLink,
            },
          ].map(({ title, handleClick }) => (
            <Button
              key={title}
              className={classes.button}
              variant="outlined"
              color="primary"
              onClick={handleClick}
            >
              {title}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}
